<template>
  <div class="select-none">
    <!-- Event type selection label -->
    <label
      for="event-type-select"
      class="block mb-1.5 text-sm font-medium text-neutral-900"
    >
      Fridags type
    </label>
    <!-- Event type selection dropdown -->
    <select
      id="event-type-select"
      v-model="computedSelectedEventType"
      @change="onEventTypeChange"
      class="bg-white border border-neutral-300 text-neutral-900 text-sm rounded-lg focus:ring-neutral-500 focus:border-neutral-500 block w-full p-2.5"
    >
      <option value="" disabled hidden>Vælg en fridags type</option>
      <optgroup label="Med saldo">
        <option
          v-for="eventType in eventTypesWithBalance"
          :key="eventType"
          :value="eventType"
        >
          {{ eventType }}
        </option>
      </optgroup>
      <optgroup label="Andre typer">
        <option
          v-for="eventType in eventTypesWithoutBalanceFiltered"
          :key="eventType"
          :value="eventType"
        >
          {{ eventType }}
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script setup>
import { inject, ref, computed, defineEmits, defineProps, watch } from "vue";
import { storeToRefs } from "pinia";

// Define props
const props = defineProps({
  selectedEventType: {
    type: String,
    default: "",
  },
});

// Define emits
const emits = defineEmits(["event-type-picked", "reset-calendar"]);

// Inject stores
const eventsStore = inject("eventsStore");
const authStore = inject("authStore");

// Extract state from stores
const { eventTypesWithBalance, eventTypesWithoutBalance } =
  storeToRefs(eventsStore);

// Computed property to filter event types without balance based on user role
const eventTypesWithoutBalanceFiltered = computed(() => {
  if (!authStore.isAdmin) {
    return eventTypesWithoutBalance.value.filter(
      (eventType) => eventType !== "Sygdom"
    );
  }
  return eventTypesWithoutBalance.value;
});

// Local state for selected event type
const localSelectedEventType = ref(props.selectedEventType);

// Computed property to sync local state with prop
const computedSelectedEventType = computed({
  get: () => localSelectedEventType.value || "",
  set: (value) => {
    localSelectedEventType.value = value;
  },
});

// Watcher to update local state when prop changes
watch(
  () => props.selectedEventType,
  (newValue) => {
    localSelectedEventType.value = newValue;
  }
);

// Method to handle event type change
const onEventTypeChange = (event) => {
  localSelectedEventType.value = event.target.value;
  emits("event-type-picked", localSelectedEventType.value);
  emits("reset-calendar");
};
</script>

<style scoped>
/* Hide the default disabled option */
select option[value=""][disabled] {
  display: none;
}
</style>
